import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

const createHelpers = (width, height, css) => {
    // somehow sizes is ending up in markup, even if it is not a valid svg attribute
    // until we have a better solution, just render it empty, instead to '[Object object]'
    const sanitizeSizes = sizes =>
        Object.defineProperty(sizes, 'toString', {
            value: () => '',
            enumerable: false,
        });

    const getDimensions = (size, sizes) => {
        if (size && typeof size.width === 'number' && typeof size.height === 'number') {
            return size;
        }

        return size && sizes[size] ? sizes[size] : { width, height };
    };

    const getCss = (size, sizes, fillColor, fillColorRule, noStyles) => {
        if (noStyles) {
            return '';
        }

        const dimensions = getDimensions(size, sizes);
        const fillRule = fillColor && fillColorRule ? `${fillColorRule}{ fill: ${fillColor}; }` : '';

        return css`
            width: ${dimensions.width}px;
            height: ${dimensions.height}px;
            ${fillRule}
        `;
    };

    const propsToCss = ({ size, sizes, fillColor, fillColorRule, noStyles }) =>
        getCss(size, sizes, fillColor, fillColorRule, noStyles);

    return {
        getCss,
        getDimensions,
        propsToCss,
        sanitizeSizes,
    };
};

const width = '1024';
const height = '1024';
const viewBox = '0 0 1024 1024';

const { getDimensions, getCss, propsToCss, sanitizeSizes } = createHelpers(width, height, css);

const sizes = sanitizeSizes({
    small: { width: 16, height: 16 },
    medium: { width: 18, height: 18 },
    large: { width: 24, height: 24 },
});

const Image = styled.svg`
    ${propsToCss}
`;

const children = (
    <Fragment>
        <path
            d="M789.333 348.437L632.896 504.896h117.333c0 129.45-105.216 234.667-234.666 234.667-39.51 0-77.056-9.792-109.526-27.392L348.95 769.28a310.187 310.187 0 00166.614 48.49c172.864 0 312.874-140.01 312.874-312.874h117.334L789.333 348.437zM280.896 504.896c0-129.472 105.195-234.667 234.667-234.667 39.488 0 77.034 9.771 109.504 27.371l57.109-57.11A310.187 310.187 0 00515.563 192c-172.886 0-312.896 140.01-312.896 312.896H85.333l156.438 156.437 156.458-156.437H280.896z"
            key="key-0"
        />
    </Fragment>
);

const defaultProps = {
    children,
    viewBox,
    fillColor: null,
    fillColorRule: '&&& path, &&& use, &&& g',
    sizes,
    size: null,
};

const propTypes = {
    fillColor: PropTypes.string,
    fillColorRule: PropTypes.string,
    viewBox: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    size: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
            height: PropTypes.number.isRequired,
            width: PropTypes.number.isRequired,
        }),
    ]),
    sizes: PropTypes.shape({
        height: PropTypes.number,
        width: PropTypes.number,
    }),
};

export default Object.assign(Image, {
    getDimensions,
    getCss,
    defaultProps,
    propTypes,
    displayName: 'Refresh',
});
